"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useBreakpoints = exports.WithBreakpoints = void 0;
var _react = require("react");
var _context = require("../context");
var _helpers = require("../helpers");
var _utils = require("../utils");
var _useMedia = require("./useMedia");
var _utils2 = require("./utils");
// Default breakpoint size
const DEFAULT_BREAKPOINT_SIZE = 'l';
const useBreakpoints = function () {
  let {
    defaultSize = DEFAULT_BREAKPOINT_SIZE,
    propsMap
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const {
    breakpoints,
    theme: {
      breakpoint: legacyBreakpoints
    }
  } = (0, _context.useStencilContext)();
  const mergedBreakpoints = {
    ...legacyBreakpoints,
    ...breakpoints
  };
  const sizes = Object.keys(mergedBreakpoints);

  // If this is being rendered in a window context, use that
  // window as the target window.
  const {
    window: targetWindow
  } = (0, _react.useContext)(_helpers.WindowContext);

  // For server side rendering, the first render won't be in a real DOM,
  // so media queries won't work. We allow the consumer to specify a default
  // configuration in that case. Once the app renders in the client, the media
  // query will overwrite this default value with the real one. This won't
  // affect apps that don't use SSR.
  const defaultMatches = sizes.reduce((defaults, size) => ({
    ...defaults,
    [size]: size === defaultSize
  }), {});
  const queries = sizes.reduce((out, size) => {
    const breakpoint = mergedBreakpoints[size];
    return {
      ...out,
      [size]: (0, _utils2.buildMediaQuery)(breakpoint)
    };
  }, {});
  const matches = (0, _useMedia.useMedia)({
    queries,
    defaultMatches,
    targetWindow
  });
  const mappedProps = (0, _react.useMemo)(() => {
    if (!propsMap) {
      return undefined;
    }
    const matchedSize = sizes.find(size => !!matches[size]) || defaultSize;
    return propsMap[matchedSize] || propsMap.default;
  }, [propsMap, matches, sizes, defaultSize]);
  return {
    matches,
    props: mappedProps
  };
};
exports.useBreakpoints = useBreakpoints;
const WithBreakpoints = exports.WithBreakpoints = (0, _utils.hookToFAC)(useBreakpoints);